<template>
    <ol class="mr-0 mt-16 -ml-5 flex-row flex-wrap justify-center font-['Poppins'] mb-8 text-xs">
        <li class="br mx-0 w-full" v-for="(item, index) in $store.state.stepsAnswers" :key="index">
            <button class="whitespace-nowrap p-4 text-white no-underline mb-4 border-none w-full text-left" :class='[is_current(index)||index==0 ? "bg-primary text-black" : "bg-globaltext p-4 cursor-pointer underline hover:bg-accent hover:text-black", index==0 ?"py-8 text-xl" : ""]' v-on:click="is_current(index) ? null : goToStep(index);">{{item.breadcrumbLabel}}</button>      
        </li>
    </ol>
</template>

<script>
export default {
    computed: {
        lastItem() {
            return this.$store.state.stepsAnswers.slice(-1)[0]
        },
    },

    methods: {
        goToStep (current_step_index) {
            this.$store.commit('goToStep', current_step_index)
        },
        is_current(index) {
            return index === (this.$store.state.stepsAnswers.length -1)
        },
    },
}
</script>
